import * as React from "react";
import classnames from "classnames";
import SuggestionItem from "../../SuggestionItem/Autocomplete/Suggestions/SuggestionItem/SuggestionItem.js";
import SuggestionTopContent from "../../SuggestionTopContent/Autocomplete/Suggestions/SuggestionTopContent/SuggestionTopContent.js";
/* empty css                 */
const Suggestions = ({
  autocompleteName,
  className,
  cursor,
  suggestions,
  suggestionTopContent,
  noResults,
  onSuggestionTopContentClick,
  onSuggestionClick,
  setHovered,
  setFocus,
  onBlur,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("autocomplete-suggestions", className) }, /* @__PURE__ */ React.createElement(
  "ul",
  {
    id: `${autocompleteName}-suggestions`,
    role: "listbox",
    className: "autocomplete-suggestions__list"
  },
  suggestionTopContent && /* @__PURE__ */ React.createElement(
    SuggestionTopContent,
    {
      suggestionTopContent,
      cursor,
      onClick: onSuggestionTopContentClick,
      setHovered,
      setFocus
    }
  ),
  suggestions.length > 0 ? suggestions.map((suggestion) => /* @__PURE__ */ React.createElement(
    SuggestionItem,
    {
      onSuggestionClick,
      suggestion,
      key: suggestion.id,
      active: cursor === suggestion.cursor,
      setHovered,
      setFocus,
      onBlur,
      "data-t": "autoCompleteSuggestion"
    }
  )) : /* @__PURE__ */ React.createElement("div", { className: "autocomplete-suggestions__no-result" }, noResults)
));
export {
  Suggestions as default
};
//# sourceMappingURL=Suggestions.js.map
